import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../../../services/AuthService';


const ProtectedRoute =  ({ component: Component, ...rest }) => (  
  <Route {...rest} render={props => (
    AuthService.isAuthenticated() ? (
      <React.Fragment>
        <Component {...props}/>
      </React.Fragment>      
    ) : (
      <Redirect to={{
        pathname: '/auth/pre-check',
        state: { from: props.location }
      }}/>
    )
  )}/>
);

export default ProtectedRoute;